<div
     class="p-t-7 p-r-10 p-l-10 p-a-4-s m-l-4-s m-r flex-column bg-col-w _content bg-col-w height-auto-s overflow-y-auto">
    <ng-form class="flex flex-column p-a-1 p-a-0-s">
        @if (contentVariant) {
        <p class="p1 center m-t-2 m-t-1-s m-b-5"
           *iCms="'copy' of contentVariant"></p>
        }
        <!-- stores list -->
        <radio-group name="multisiteModel"
                     [(ngModel)]="selectedStore">
            @for (store of stores; track $index) {
            <div class="p-t-2 p-l-3 p-r-3 p-b-3 p-a-4-s b-a b-col-42 m-b-6 m-b-5-s shipping-selection pos-relative"
                 (click)="pick(store)"
                 [class.bg-col-5]="store.siteId === selectedStore">
                @if (store.icon) {
                <!-- store image -->
                <img [image]="store.icon"
                     class="icon pos-absolute right-4 top-5-s fs-4 b-radius-max"
                     *iCms="'icon' of store">
                }
                <!-- checkbox -->
                <radio [value]="store.siteId"
                       class="block w-12 p-l-6 radio-full-width-label">
                    <!-- store information -->
                    <div class="flex flex-middle">
                        <!-- store name -->
                        <h5 class="p1 col-11"
                            *iCms="'title' of store"
                            text></h5>
                        <!-- subtitle -->
                        @if (store.subtitle) {
                        <p class="m-l-2 p2 col-12"
                           *iCms="'subtitle' of store"
                           text></p>
                        }
                    </div>
                    <!-- details -->
                    <div class="text p2 col-11 m-t-1"
                         *iCms="'details' of store; content: 'html'">
                    </div>
                </radio>
            </div>
            }
        </radio-group>
        @if (contentVariant) {
        <div class="center">
            <button class="w-12 m-b-2-s button"
                    (click)="close()">
                <span *iCms="'buttonCopy' of contentVariant"></span>
            </button>
        </div>
        }
    </ng-form>
</div>
